import { Theme } from '@material-ui/core/styles';

export const getMuiDialogContent = (theme: Theme): Record<string, unknown> => ({
  MuiDialogContent: {
    root: {
      padding: theme.spacing(0, 2, 2),

      '& .MuiFormControl-root': {
        marginBottom: theme.spacing(2),
      },

      '& .MuiTypography-h1': {
        fontSize: theme.typography.pxToRem(28),
      },

      '& .MuiTypography-body1': {
        marginBottom: theme.spacing(2),
      },

      '& label': {
        paddingBottom: theme.spacing(2), // ?? what is does?
      },

      '& .externalList': {
        listStyle: 'none',
        padding: 0,

        '& li': {
          borderBottom: '1px solid transparent',
          borderTop: `1px solid ${theme.palette.grey[200]}`,
          marginBottom: '1px',
          width: '100%',
        },

        '& a': {
          alignItems: 'center',
          color: theme.palette.common.black,
          display: 'flex',
          flexFlow: 'row nowrap',
          justifyContent: 'space-between',
          padding: theme.spacing(2.5, 0),
          textDecoration: 'none',
          width: '100%',

          '& svg': {
            marginRight: theme.spacing(1),
          },

          '& .MuiTypography-body1': {
            fontWeight: theme.typography.fontWeightMedium,
            marginBottom: 0,
          },
        },
      },

      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(0, 2.5, 2.5),

        '& .MuiTypography-h2': {
          marginBottom: theme.spacing(2.5),
        },

        '& .MuiTypography-body1': {
          marginBottom: theme.spacing(2.5),
        },

        '& .externalList': {
          '& li:last-of-type': {
            borderBottom: `1px solid ${theme.palette.grey[200]}`,
          },

          '& li:hover': {
            borderColor: 'transparent',
            boxShadow: `0 3px 0 -2px ${theme.palette.primary.main}, 0 -3px 0 -2px ${theme.palette.primary.main}`,
          },
        },

        '& [class*=snackbar]': {
          '& .MuiTypography-body1': {
            marginBottom: 0,
          },
        },
      },
    },
  },
});
